import { isFileType } from '@savgroup-front-common/core/helpers/AdditionalInformations/isFileType';
import { ClaimContext } from '@savgroup-front-common/types';

import { Reason, RELATED_TO } from '../../../../types';

export const computeReasonSteps = ({
  reason,
  claims,
}: {
  claims?: ClaimContext[];
  reason?: Reason;
}) => {
  const isMultiProduct = claims ? claims.length > 1 : undefined;

  const hasAdditionnalInformationFileRelatedToProduct =
    reason?.neededInformation.some(
      (item) =>
        isFileType(item) &&
        item.relatedTo === RELATED_TO.PRODUCT &&
        isMultiProduct === true,
    );

  const hasAdditionnalInformationProductRelatedToProduct =
    reason?.neededInformation.some(
      (item) =>
        !isFileType(item) &&
        item.relatedTo === RELATED_TO.PRODUCT &&
        isMultiProduct === true,
    );

  const hasAdditionnalInformationFileRelatedToClaim =
    reason?.neededInformation.some(
      (item) =>
        isFileType(item) &&
        item.relatedTo === RELATED_TO.CLAIM &&
        isMultiProduct === true,
    );

  const hasAdditionalInformationFile = reason?.neededInformation.some(
    (item) => isFileType(item) && isMultiProduct === false,
  );

  return {
    hasAdditionnalInformationFileRelatedToProduct,
    hasAdditionnalInformationProductRelatedToProduct,
    hasAdditionnalInformationFileRelatedToClaim,
    hasAdditionalInformationFile,
  };
};
